import React from "react";
import { Link } from "react-router-dom";
import EmptyState from "../EmptyState";

// Panel de eventos del campus en el dashboard. Muestra los más recientes
// de forma compacta y enlaza al detalle y al listado completo.
const arr = (x) => (Array.isArray(x) ? x : []);

// Quita etiquetas HTML del cuerpo de la noticia para un resumen corto.
const resumen = (html, max = 110) => {
    const texto = String(html || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    return texto.length > max ? `${texto.substr(0, max)}…` : texto;
};

const DashEventos = ({ eventos }) => {
    const lista = arr(eventos).slice(0, 3);

    return (
        <div className="card h-100">
            <div className="card-header d-flex align-items-center justify-content-between">
                <span>
                    <i className="fa fa-calendar mr-2" aria-hidden="true"></i>
                    Eventos del campus
                </span>
                <Link to="/eventos" className="esen-dash-verlink">
                    Ver todos
                </Link>
            </div>
            <div className="card-body">
                {lista.length > 0 ? (
                    <ul className="esen-dash-eventos">
                        {lista.map((ev) => (
                            <li key={ev.id_noticia}>
                                <Link
                                    to={`/detalleventos?id_noticia=${ev.id_noticia}`}
                                    className="esen-dash-evento"
                                >
                                    <span className="esen-dash-evento-head">
                                        <span className="esen-dash-evento-titulo">{ev.titulo}</span>
                                        {ev.unidad ? (
                                            <span className="esen-chip esen-chip--info">{ev.unidad}</span>
                                        ) : null}
                                    </span>
                                    {resumen(ev.noticia) ? (
                                        <span className="esen-dash-evento-desc">{resumen(ev.noticia)}</span>
                                    ) : null}
                                </Link>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <EmptyState icon="fa-calendar-o" title="Sin eventos por ahora">
                        Cuando se publiquen eventos o noticias aparecerán aquí.
                    </EmptyState>
                )}
            </div>
        </div>
    );
};

export default DashEventos;
